import {
  CriticalSeverityColors,
  MinorSeverityColors,
  ModerateSeverityColors,
  StableSeverityColors,
} from '@twaice-fe/frontend/shared/utilities';
import { AlertSeverity, LookbackDaysOption } from './component-sidebar.types';

export const ONGOING_CIRCLE_FILL_COLOR = '#2F54EB';
export const ONGOING_TAG_FILL_COLOR = '#F0F5FF4D';
export const ONGOING_TAG_TEXT_COLOR = '#10239e';
export const CLEARED_TAG_FILL_COLOR = '#E6FFEF4D';
export const CLEARED_TAG_TEXT_COLOR = '#005939';

export interface AlertIconData {
  edgeColor: string;
  fillColor: string;
  iconName: string;
  tagBackgroundColor: string;
  tagBorderColor: string;
  tagTextColor: string;
  tagIconColor: string;
  tagColorName?: string;
}

export const alertIconConfig: Record<AlertSeverity, AlertIconData> = {
  [AlertSeverity.High]: {
    edgeColor: CriticalSeverityColors.text,
    fillColor: CriticalSeverityColors.background,
    iconName: 'alert-triangle',
    tagBackgroundColor: CriticalSeverityColors.background,
    tagBorderColor: CriticalSeverityColors.border,
    tagTextColor: CriticalSeverityColors.text,
    tagIconColor: CriticalSeverityColors.text,
    tagColorName: 'red',
  },
  [AlertSeverity.Medium]: {
    edgeColor: ModerateSeverityColors.icon,
    fillColor: ModerateSeverityColors.background,
    iconName: 'exclamation-circle',
    tagBackgroundColor: ModerateSeverityColors.background,
    tagBorderColor: ModerateSeverityColors.border,
    tagTextColor: ModerateSeverityColors.text,
    tagIconColor: ModerateSeverityColors.icon,
    tagColorName: 'gold',
  },
  [AlertSeverity.Minor]: {
    edgeColor: MinorSeverityColors.text,
    fillColor: MinorSeverityColors.background,
    iconName: 'alert-square-rounded',
    tagBackgroundColor: MinorSeverityColors.background,
    tagBorderColor: MinorSeverityColors.border,
    tagTextColor: MinorSeverityColors.text,
    tagIconColor: MinorSeverityColors.text,
  },
  [AlertSeverity.Normal]: {
    edgeColor: StableSeverityColors.accent,
    fillColor: StableSeverityColors.background,
    iconName: 'circle-filled',
    tagBackgroundColor: 'rgba(21, 205, 118, 0.15)',
    tagBorderColor: 'rgba(21, 205, 118, 0.5)',
    tagTextColor: StableSeverityColors.accent,
    tagIconColor: StableSeverityColors.accent,
    tagColorName: 'green',
  },
};

export const DEFAULT_LOOKBACK_DAYS = 7;

export const LOOKBACK_DAYS_OPTIONS: LookbackDaysOption[] = [
  { days: 1, label: '24 hours' },
  { days: 7, label: '7 days' },
  { days: 30, label: '30 days' },
  { days: 90, label: '90 days' },
];
